import { render, staticRenderFns } from "./suggestDetails.vue?vue&type=template&id=792af263"
import script from "./suggestDetails.vue?vue&type=script&lang=js"
export * from "./suggestDetails.vue?vue&type=script&lang=js"
import style0 from "./suggestDetails.vue?vue&type=style&index=0&id=792af263&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports